// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/get-in-touch-bg-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/svg/leftBannerSplash.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_get__in__touch__aF7WZ {
    width: 100%;
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    padding: 0px 0px 50px 0px;
    background-position: 100% -60px;
    background-repeat: no-repeat;
    background-size: inherit;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.style_get__in__touch__aF7WZ::before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 310px;
    left: -150px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    z-index: -1;
}

.style_get__in__touch_wrapper__XL-gB {
    width: 60%;
    max-width: 658px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.style_get__in__touch_wrapper__XL-gB h2,
.style_get__in__touch_wrapper__XL-gB p {
    text-align: center;
}

.style_get__in__touch_wrapper__XL-gB h2,
.style_reach__out__lnYPP h2 {
    margin-bottom: 0px;
}

.style_get__in__touch_wrapper__XL-gB p {
    margin-top: 4px;
    width: 80%;
}

.style_get__in__touch_wrapper__XL-gB form {
    width: 100%;
    margin: 40px 0px;
}

.style_get__in__touch_wrapper__XL-gB button {
    margin-top: 10px;
    font-weight: 700;
}

.style_get__in__touch_wrapper__XL-gB .style_double__input__FYUgS {
    display: flex;
    flex-direction: row;
    gap: 20px;
    margin-bottom: 15px;
}

.style_get__in__touch_wrapper__XL-gB .style_double__input__FYUgS>div {
    width: 48%;
    margin-bottom: 10px;
}

.style_get__in__touch_wrapper__XL-gB .style_double__input__FYUgS input {
    height: 58px;
}

.style_get__in__touch_wrapper__XL-gB textarea {
    width: 99%;
    height: 120px;
    margin-bottom: 20px;
}

.style_get__in__touch_wrapper__XL-gB button {
    width: 100%;
    display: flex;
    justify-content: center;
}

.style_reach__out__lnYPP {
    width: 100%;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    padding: 50px 0px 100px 0px;
    background-color: var(--grey-06);
}

.style_reach__out__lnYPP * {
    color: var(--white);
    text-decoration: none;
}

.style_reach__out_wrapper__3Z6JX {
    width: 70%;
    max-width: 1124px;
}

.style_reach__out_cards__4mfFY {
    display: flex;
    gap: 42px;
    flex-wrap: wrap;
    margin-top: 60px;
    justify-content: center;
    text-decoration: none;
}

.style_contact__map__f4ImH {
    width: 100%;
    height: 500px;
}

@media (max-width: 768px) {
    .style_get__in__touch_wrapper__XL-gB .style_double__input__FYUgS {
        flex-direction: column;
    }

    .style_get__in__touch_wrapper__XL-gB .style_double__input__FYUgS>div {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/contact-us/style.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,+BAA+B;IAC/B,4BAA4B;IAC5B,wBAAwB;IACxB,yDAAmE;AACvE;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,yDAA4D;IAC5D,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,UAAU;AACd;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".get__in__touch {\n    width: 100%;\n    display: flex;\n    position: relative;\n    align-items: center;\n    justify-content: center;\n    padding: 0px 0px 50px 0px;\n    background-position: 100% -60px;\n    background-repeat: no-repeat;\n    background-size: inherit;\n    background-image: url(../../assets/images/get-in-touch-bg-icon.png);\n}\n\n.get__in__touch::before {\n    content: '';\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 310px;\n    left: -150px;\n    background-image: url(../../assets/svg/leftBannerSplash.svg);\n    background-repeat: no-repeat;\n    z-index: -1;\n}\n\n.get__in__touch_wrapper {\n    width: 60%;\n    max-width: 658px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.get__in__touch_wrapper h2,\n.get__in__touch_wrapper p {\n    text-align: center;\n}\n\n.get__in__touch_wrapper h2,\n.reach__out h2 {\n    margin-bottom: 0px;\n}\n\n.get__in__touch_wrapper p {\n    margin-top: 4px;\n    width: 80%;\n}\n\n.get__in__touch_wrapper form {\n    width: 100%;\n    margin: 40px 0px;\n}\n\n.get__in__touch_wrapper button {\n    margin-top: 10px;\n    font-weight: 700;\n}\n\n.get__in__touch_wrapper .double__input {\n    display: flex;\n    flex-direction: row;\n    gap: 20px;\n    margin-bottom: 15px;\n}\n\n.get__in__touch_wrapper .double__input>div {\n    width: 48%;\n    margin-bottom: 10px;\n}\n\n.get__in__touch_wrapper .double__input input {\n    height: 58px;\n}\n\n.get__in__touch_wrapper textarea {\n    width: 99%;\n    height: 120px;\n    margin-bottom: 20px;\n}\n\n.get__in__touch_wrapper button {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n}\n\n.reach__out {\n    width: 100%;\n    display: flex;\n    text-align: center;\n    align-items: center;\n    justify-content: center;\n    padding: 50px 0px 100px 0px;\n    background-color: var(--grey-06);\n}\n\n.reach__out * {\n    color: var(--white);\n    text-decoration: none;\n}\n\n.reach__out_wrapper {\n    width: 70%;\n    max-width: 1124px;\n}\n\n.reach__out_cards {\n    display: flex;\n    gap: 42px;\n    flex-wrap: wrap;\n    margin-top: 60px;\n    justify-content: center;\n    text-decoration: none;\n}\n\n.contact__map {\n    width: 100%;\n    height: 500px;\n}\n\n@media (max-width: 768px) {\n    .get__in__touch_wrapper .double__input {\n        flex-direction: column;\n    }\n\n    .get__in__touch_wrapper .double__input>div {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"get__in__touch": `style_get__in__touch__aF7WZ`,
	"get__in__touch_wrapper": `style_get__in__touch_wrapper__XL-gB`,
	"reach__out": `style_reach__out__lnYPP`,
	"double__input": `style_double__input__FYUgS`,
	"reach__out_wrapper": `style_reach__out_wrapper__3Z6JX`,
	"reach__out_cards": `style_reach__out_cards__4mfFY`,
	"contact__map": `style_contact__map__f4ImH`
};
export default ___CSS_LOADER_EXPORT___;
